import { FuseNavigation } from '@fuse/types';
export const navigation: FuseNavigation[] = [
 
    {
        id: 'realtime',
        title: 'Usage',
        translate: 'NAV.MODULE.REALTIME',
        type: 'item',
        icon: 'alarm',
        url: '/module/usage'
        /*,
        badge: {
            title: '25',
            translate: 'NAV.SAMPLE.BADGE',
            bg: '#F44336',
            fg: '#FFFFFF'
        }
        */
    },
       /*
    {
        id: 'talking',
        title: 'Talking',
        translate: 'NAV.MODULE.TALKING',
        type: 'item',
        icon: 'phone_in_talk',
        url: '/module/talking'
        /* ,
        badge: {
            title: '25',
            translate: 'NAV.SAMPLE.BADGE',
            bg: '#F44336',
            fg: '#FFFFFF'
        
        }

    },
    
    {
        id: 'usage',
        title: 'Usage',
        translate: 'NAV.MODULE.USAGE',
        type: 'item',
        icon: 'update',
        url: '/module/realtime'
    },
*/
{
    id: 'deepcall',
    title: 'Deep Call',
    translate: 'NAV.MODULE.TALKING',
    type: 'item',
    icon: 'phone_in_talk',
    url: '/module/deepcall'
    

},

{
        id: 'inventory',
        title: 'Inventory',
        translate: 'NAV.MODULE.INVENTORY',
        type: 'item',
        icon: 'assignment_turned_in',
        url: '/module/inventory'
    },
    /*
    {
        id: 'geoprocess',
        title: 'Geoprocess',
        translate: 'NAV.MODULE.GEO',
        type: 'item',
        icon: 'gps_fixed',
        url: '/module/geoprocess'
    },
  
 {
    id: 'voicebiomeric',
    title: 'Voice Biometric',
    translate: 'NAV.MODULE.VOICE_BIOMETRIC',
    type: 'item',
    icon: 'record_voice_over',
    url: '/module/voicebiometric'
},*/
{
        id: 'settings',
        title: 'Condigurações',
        translate: 'NAV.SETTING',
        type: 'item',
        icon: 'settings',
        url: '/settings'
    }, 
    
    
    {
        id: 'infra',
        title: 'Grupos',
        translate: 'NAV.INFRA',
        type: 'item',
        icon: 'domain',
        url: '/register/infra'
    }
    , 
    
    {
        id: 'licences',
        title: 'Licences',
        translate: 'NAV.LICENCES',
        type: 'item',
        icon: 'verified_user',
        url: '/register/licences'
    }
    /*
    , 


    
    {
                id       : 'records',
                title    : 'Records',
                translate: 'NAV.RECORDS',
                type     : 'collapsable',
                icon     : 'dashboard',
                children : [
                    {
                        id   : 'devices',
                        title: 'Devices',
                        translate: 'NAV.DEVICES',
                        type : 'item',
                        url  : '/register/devices'
                    },
                    {
                        id   : 'beeps',
                        title: 'Beeps',
                        translate: 'NAV.BEEPS',
                        type : 'item',
                        url  : '/register/beeps'
                    },
                    {
                        id   : 'equalizer',
                        title: 'Equalizer',
                        translate: 'NAV.EQUALIZER',
                        type : 'item',
                        url  : '/register/equalizer'
                    },
                    {
                        id   : 'voicephrases',
                        title: 'Voice Phrases',
                        translate: 'NAV.VOICE_PHRASES',
                        type : 'item',
                        url  : '/register/voicephrases'
                    }
                    
                ]
            }
    /*
    {
        id: 'profile',
        title: 'Profile',
        translate: 'NAV.PROFILE',
        type: 'item',
        icon: 'mood',
        url: '/register/profile'
    }
    */

];

export const navigation2: FuseNavigation[] = [
 
    
    {
        id: 'infra',
        title: 'Infra',
        translate: 'NAV.INFRA',
        type: 'item',
        icon: 'domain',
        url: '/register/infra'
    }
    , 
    
    {
        id: 'licences',
        title: 'Licences',
        translate: 'NAV.LICENCES',
        type: 'item',
        icon: 'verified_user',
        url: '/register/licences'
    }
    

];